import styled from 'styled-components';
import StyledToastProps, { closeIcon, toastFont } from '../Errors/StyledToastProps';

export default styled.div`
	${StyledToastProps}
	${toastFont}
	padding: 0;
	color: var(--font-color);
	width: calc(100% - 2rem);
	border: var(--border);
	margin: 0 1rem;
	position: absolute;
	top: 1rem;
	display: table;
	background: var(--bg);
	box-shadow: var(--box-shadow);
	&.hide-error-summary {
		display: none;
	}

	.close-icon {
		${closeIcon}
		cursor: pointer;
		position: absolute;
		right: 0.9rem;
		top: 0.9rem;
		fill: ${(props) => props.theme.color[`black`]};
	}

	.error-message {
		display: inline-block;
		padding: var(--padding);
		color: var(--font-color);
		width: calc(100% - 3rem);
	}
`;
